import React, { useState } from "react";
import Button from "../../components/Button";
import CardLayout from "../../components/CardLayout";
import Input from "../../components/Input";
import Select from "../../components/Select";

const UpdateProfile = () => {
  const [data, setData] = useState({
    sponsorId: "f8sf8s5",
    memberId: "mono7d8sf",
    phone: "+911254555",
    name: "mlm point",
    gender: "Male",
    country: "India",
  });
  const handleChange = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value,
    });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(data);
  };
  const [countries, setCountries] = useState([]);
  fetch("https://restcountries.com/v2/all")
    .then((response) => response.json())
    .then((json) => {
      setCountries(json.map((c) => c.name));
    });
  console.log(countries);
  return (
    <div className="mono_userUpdate_page_wrapper">
      <CardLayout
        style={{ backgroundColor: "#fff" }}
        className="mono_userupdate_card"
      >
        <div className="mono_userupdate_title">
          <h2>update profile</h2>
        </div>
        <div className="mono_userupdate_field">
          <form onSubmit={handleSubmit}>
            <div className="form_group">
              <Input
                label="Sponsor ID"
                type="text"
                value={data.sponsorId}
                name="sponsorId"
                onChange={handleChange}
                inputGroupClass="left"
              />
              <Input
                label="Member ID"
                type="text"
                value={data.memberId}
                name="memberId"
                onChange={handleChange}
                inputGroupClass="right"
              />
            </div>
            <div className="form_group">
              <Input
                label="Phone"
                type="text"
                value={data.phone}
                name="phone"
                onChange={handleChange}
                inputGroupClass="left"
              />
              <Input
                label="Name"
                type="text"
                value={data.name}
                name="name"
                onChange={handleChange}
                inputGroupClass="right"
              />
            </div>
            <div className="form_group" style={{display: "inherit"}}>
              <div>
                <Select
                  label="Gender"
                  name="gender"
                  value={data.gender}
                  onChange={handleChange}
                  options={["Male", "Female", "Others"]}
                />
              </div>
            </div>
            <div className="form_group" style={{display: "inherit"}}>
              <div>
                <Select
                  label="Country"
                  name="country"
                  value={data.country}
                  onChange={handleChange}
                  options={countries}
                />
              </div>
            </div>
            <div className="form_group">
              <Button type="submit">update profile</Button>
            </div>
          </form>
        </div>
      </CardLayout>
    </div>
  );
};

export default UpdateProfile;
